import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import TaholaLoader from '../../assets/TaholaLoader.gif';
import Paper from '@mui/material/Paper';


const Loader = () => {
    return (
        <Box ml='70px' >
            <Toolbar />
            <Box style={{ height: '90vh', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                {/* <CircularProgress /> */}
                <Paper square elevation={2}><img src={TaholaLoader} alt="Loader" style={{width: 'auto', height:'100px'}} /></Paper>
            </Box>
        </Box >
    );
}

export default Loader;